export { default, type TarifSectionProps } from './TarifSection';
